import * as React from "react";
import ReactSelect from "react-select";
import { IInputFieldProps, SelectFieldOption, SelectFieldSchema } from "@generation/core";
import { notNullOrUndefined } from "@core/utils";

interface ReactSelectFieldProps extends IInputFieldProps<SelectFieldSchema> {
  value?: any;
  onChange?: (event: any) => void;
  options: SelectFieldOption[];
  className: string;
  isLoading: boolean;
  isDisabled: boolean;
}

export const getSelectedValues = (
  field: SelectFieldSchema,
  options: SelectFieldOption[],
  value?: any
): SelectFieldOption | SelectFieldOption[] | undefined => {
  if (field.multiSelect === true && Array.isArray(value)) {
    const values = value
      .map((itemValue) => options.find((item) => item.value === itemValue))
      .filter(notNullOrUndefined);

    return values.length > 0 ? values : undefined;
  }
  return options.find((option) => option.value === value);
};

export const ReactSelectField = (props: ReactSelectFieldProps) => {
  const value = getSelectedValues(props.field, props.options, props.value);

  const hasValue = value !== undefined;
  return (
    <ReactSelect
      className={props.className}
      styles={{
        control: (base) => {
          base.minHeight = 50;
          base.borderRadius = 0;
          base.borderColor = "#dadada";

          return base;
        },
        input: (base) => {
          base.height = 40;
          base.marginTop = -10;

          return base;
        },
        valueContainer: (base) => {
          base.padding = "0 2.36rem 0 2.36rem";
          base.textAlign = "justify";

          return base;
        },
        singleValue: (base) => {
          base.height = 20;
          return base;
        },
        indicatorsContainer: (base) => {
          base.height = 48;
          return base;
        }
      }}
      options={props.options}
      isMulti={props.field.multiSelect}
      onChange={(newValue) => {
        if (!props.onChange) {
          return;
        }

        if (props.field.multiSelect === true) {
          //@ts-ignore
          props.onChange(newValue?.map((item) => item.value));
        } else {
          //@ts-ignore
          props.onChange(newValue?.value ?? "");
        }
      }}
      //@ts-ignore
      ref={props.inputRef}
      placeholder=""
      isClearable={
        hasValue ? (props.field.isClearable !== undefined ? props.field.isClearable : true) : false
      }
      value={value}
      name={props.name}
      id={props.name}
      isLoading={props.isLoading}
      controlShouldRenderValue={hasValue}
      isDisabled={props.isLoading || props.isDisabled}
    />
  );
};
